import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type InfoMessageProps = BoxProps;

const testId = "InfoMessage";
const InfoMessage = (props: InfoMessageProps) => {
    const { sx, children, className, ...otherProps } = props;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            sx={{
                ...sx,
                backgroundColor: "var(--proda-light-blue)",
                color: "var(--proda-blue)",
                borderRadius: "4px",
                padding: "10px 20px",
                display: "inline-block",
                textAlign: "center",
            }}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

export default InfoMessage;
